// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"styles_sliderWrapper__KLLK-","singleImageContainer":"styles_singleImageContainer__2Wh8w","image":"styles_image__26nK2","carousel":"styles_carousel__10oEM"};